import React from "react";
/**
 * Skeleton para tablas: N filas x M celdas.
 */
export default function TableSkeleton({ rows = 5, cols = 5 }: Record<string, any>): any {
    return (<div className="overflow-x-auto rounded-card border border-border bg-surface">
      <table className="min-w-full divide-y divide-border">
        <thead className="bg-surface-sunken">
          <tr>
            {Array.from({ length: cols }).map((_: any, i: any): any => (<th key={i} className="px-4 py-3">
                <div className="h-4 bg-border rounded animate-pulse w-20"/>
              </th>))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {Array.from({ length: rows }).map((_: any, rowIdx: any): any => (<tr key={rowIdx} className="animate-pulse">
              {Array.from({ length: cols }).map((_: any, colIdx: any): any => (<td key={colIdx} className="px-4 py-3">
                  <div className="h-4 bg-border/60 rounded" style={{ width: colIdx === 0 ? 80 : colIdx === 1 ? "70%" : 60 }}/>
                </td>))}
            </tr>))}
        </tbody>
      </table>
    </div>);
}
